import React, { Component } from 'react';
import { routes } from '../../constants';
import dog404 from '../../images/dog-404.svg';
import { Image, Col, Grid, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

/*
 * A '404' page shown when no other routes match.
 * See https://reacttraining.com/react-router/web/example/no-match
 */
class NoMatch extends Component {
  render() {
    return (
      <section id='error'>
        <Grid>
          <h2>Error 404</h2>
          <h1>Oops!</h1>
          <Row className='no-gutter'>
            <Col xs={12} md={4} mdOffset={4}>
              <p>
                {'We can\'t seem to find the page you\'re looking for. It\'s either been moved, deleted or does not exist. Take a step back to where you were, or head straight to our '}
                <Link to={routes.app.dashboard}>homepage</Link>{'.'}</p>
            </Col>
          </Row>

          <Row className='no-gutter'>
            <Col xs={8} xsOffset={2} md={4} mdOffset={4}>
              <Image src={dog404} alt='Not Found' responsive />
            </Col>
          </Row>
        </Grid>
      </section >
    );
  }
}

export default NoMatch;



// WEBPACK FOOTER //
// ./src/containers/pages/no-match.js